<template>
  <Card>
    <CardHeading
      heading="Call to action"
      :showCapacity="false"
      :showButton="false"
    />
    <Input
      id="btnLabel"
      @input-change="handleChange"
      name="text"
      label="Button label"
      class="mb-4"
      styles="font-weight: 400"
      placeholder="Contact partner"
      :disabled="textDisabled"
      :value="globalCtaText || (button === undefined ? '' : button.text)"
    />
    <Input
      id="btnUrl"
      @input-change="updateBtnUrl"
      name="url"
      label="Button URL"
      class="mb-2"
      styles="font-weight: 400"
      placeholder="https://calltoaction.com"
      @error-change="updateError({ state: $event, key: 'button' })"
      :disabled="urlDisabled"
      :fieldValidator="checkError"
      :value="globalCtaUrl || (button === undefined ? '' : button.url)"
    />
  </Card>
</template>

<script>
import Card from '@/components/DesignSystem/Card';
import CardHeading from '@/components/DesignSystem/CardHeading';
import Input from '@/components/DesignSystem/Input';

export default {
  name: 'CTAContentSection',
  props: {
    namespace: String,
    globalCtaUrl: {
      type: String,
      default: undefined,
    },
    globalCtaText: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      urlError: undefined,
    };
  },
  components: {
    Input,
    CardHeading,
    Card,
  },
  computed: {
    urlDisabled() {
      return !!this.globalCtaUrl;
    },
    textDisabled() {
      return !!this.globalCtaText;
    },
    button() {
      return this.$store.getters[`${this.namespace}/button`];
    },
  },
  methods: {
    updateBtnUrl({ key, value }) {
      if (value && !value.includes('http')) {
        value = 'https://' + value;
      }
      this.handleChange({ key, value });
    },
    checkError(value) {
      // eslint-disable-next-line no-useless-escape
      const re = /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)?[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?(\/.*)?$/;
      const valid = re.test(value);

      if (valid) {
        return undefined;
      }
      return {
        value: value,
        message: 'Please enter a valid URL',
      };
    },
    updateError(payload) {
      this.$store.dispatch(`${this.namespace}/updateError`, {
        key: payload.key,
        label: 'Button',
        state: payload.state,
        message: 'Please enter a valid URL',
      });
    },
    handleChange(payload) {
      this.$store.dispatch(`${this.namespace}/updateButton`, payload);
      this.$store.dispatch(`${this.namespace}/addDirtyTab`, {
        endpoint: 'button/',
        storeKey: 'button',
      });
      this.$forceUpdate();
    },
  },
};
</script>
